<section class="container">
  <header class="header-actions">
    <button class="header-actions header-actions__item"
            mat-button
            (click)="onClickExpandAll()">EXPAND ALL</button>
    <button class="header-actions header-actions__item"
            mat-button
            (click)="onClickCollapseAll()">COLLAPSE ALL</button>
  </header>

  <mat-accordion multi
                 #accordion="matAccordion">
    <ifbp-business-form class="panel"
                        [form]="submissionForm.controls.businessInformation">
    </ifbp-business-form>
    <ifbp-owner-information-form class="panel"
                                 [form]="submissionForm.controls.ownersInformation">
    </ifbp-owner-information-form>
    <ifbp-documents-section class="panel"
                            [documentsData]="documentsData">
    </ifbp-documents-section>
  </mat-accordion>
</section>
